<!--  -->
<template>
    <div>
        <p v-html="value">

        </p>
    </div>
</template>
<script>
export default {
    data() {
        return {
            value:""
        }
    },
    created() {
        this.value=this.$route.query.value
    },
    mounted() {

    },
    methods: {},
}
</script>
<style scoped lang='scss'>
    div{
        padding: .3rem;
        box-sizing: border-box;
        >p{
            font-size: 16px;
            /deep/ img{
                width: 100% !important;
                height: auto !important;
            }
        }
        
    }
</style>


// WEBPACK FOOTER //
// src/views/zhinan.vue